/**
* RelytArt
*
* Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
* Copyright (c) 2022 RelytArt
*
* License: https://docs.google.com/document/d/1UD7jhCYWRXSxhx4A5vMeGVTjujwLM39BmvjwA0eFFfk/edit?usp=sharing
*
*/

// node_modules
import { v4 as UuidV4, validate as uuidValidate } from 'uuid';

class UuidUtils {

  /**
  * @returns {String}
  */
  static _private_generate() {
    return UuidV4();
  }

  /**
  * @param {String} uuid
  * @returns {Boolean}
  */
  static validate(uuid) {
    return uuidValidate(uuid);
  }

  /**
  * @param {Array} uuidsInUse
  * @returns {String}
  */
  static uuid(uuidsInUse) {
    let newUUID = UuidUtils._private_generate();
    if(uuidsInUse) {
      while(uuidsInUse.includes(newUUID)) {
        newUUID = UuidUtils._private_generate();
      }
    }
    return newUUID;
  }
}
export default UuidUtils;
